import { Model as LibXModel, IModelOptions } from 'libx'
import { action } from 'mobx'

/**
 * Model base class with better type checking.
 */
export abstract class Model<A, Self> {
  constructor() {
    this.set = action('set', this.set.bind(this))
  }

  /**
   * `set` the attributes on the model without parsing first.
   * @param attrs
   * @param opts
   */
  set(
    attrs: Partial<Self>,
    opts?: Omit<IModelOptions, 'parse'> & { parse?: false }
  ): Self

  /**
   * Parses `attrs` and sets the result on the model.
   *
   * @param attrs
   * @param opts
   */
  set(
    attrs: Partial<A>,
    opts: Omit<IModelOptions, 'parse'> & { parse: true }
  ): Self

  /**
   * @param attrs
   * @param opts
   */
  set(attrs: any, opts?: any): any {
    LibXModel.prototype.set.call(this, attrs, opts)
    return this as any
  }

  /**
   * Parses the attributes into model properties.
   * @param attrs the attributes to parse
   */
  abstract parse(attrs: Partial<A>): Partial<Self>
}
